import React from 'react';
import { Form } from 'antd';
import cn from 'classnames';
import styles from './FormItem.module.scss';

const FormItem = ({ className, ...props }) => {
  return (
    <Form.Item
      colon={false}
      {...props}
      className={cn(styles.root, className)}
    />
  );
};

export default FormItem;
